export default {
  name: 'SurveyShader',
  uniforms: {
    uColor: {
      value: [],
    },
    uRadius: {
      value: 1,
    },
    uLightPositions: { value: [] },
    uLightIntensities: { value: [0.4, 0.4] },
    uAmbientIntensity: { value: 0.7 },
  },
  vertexShader: /* glsl */ `
    #include <common>
    #include <logdepthbuf_pars_vertex>
    uniform vec3 uColor;
    uniform float uRadius;
    varying vec2 vUv;
    varying vec3 vColor;
    varying vec3 vNormal;

    void main() {
      vUv = uv;
      vNormal = normalMatrix * normal;
      vColor = uColor;

      vec3 radiusAdjustedPosition = position + normal * (uRadius - 1.0); // assume geometries created with radius of 1.0

      gl_Position = projectionMatrix * modelViewMatrix * vec4(radiusAdjustedPosition, 1.0 );
      #include <logdepthbuf_vertex>
    }`,
  fragmentShader: /* glsl */ `
    #include <common>
    #include <logdepthbuf_pars_fragment>
    uniform vec3 uLightPositions[2];
    uniform float uLightIntensities[2];
    uniform float uAmbientIntensity;
    varying vec2 vUv;
    varying vec3 vColor;
    varying vec3 vNormal;

    void main() {
      #include <logdepthbuf_fragment>

      vec3 baseColor = vColor;
      vec3 color = vec3(0.0);
      for (int i = 0; i < 2; i++) {
        float lightIntensity = max(dot(normalize(vNormal), normalize(uLightPositions[i])), 0.0);
        color += baseColor * lightIntensity * uLightIntensities[i];
      }

      float ambientLightIntensity = uAmbientIntensity;
      color += baseColor * ambientLightIntensity;
      
      gl_FragColor = vec4(color, 1.0);
    }`,
}
